import { createContext } from 'react';

export const ContentContext = createContext(null);